// Пасхалка в блоке «Шаги»: от 10 000 шагов за день в шапке загорается 万 — «десять тысяч»;
// японский шагомер — 万歩計, «счётчик 10 000 шагов». Знак — глиф tauWanRound из
// scripts/icons.mjs (万 с крючком τ), здесь черты в порядке письма: перекладина, крючок, откидная —
// так он «пишется» при появлении (.wan-draw в index.css, без анимации при reduced motion).
// Касание открывает подпись.

import { useState } from 'react'

const STROKES =
  'M8.1 11.6C8.9 10.3 9.9 9.6 11.4 9.6H23.6' +
  'M14.3 14.6H21.4V19.4C21.4 21.7 20.2 22.9 18.2 22.9C17.4 22.9 16.7 22.6 16.1 22.1' +
  'M14.2 9.6V14.2C14.2 18.4 12.7 21.2 9.6 23.2'

const CAPTION = '万歩 — десять тысяч шагов'

export function WanMark() {
  const [open, setOpen] = useState(false)
  return (
    <span className="relative inline-flex">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={CAPTION}
        title={CAPTION}
        className="-m-2 inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg text-accent hover:bg-surface-2 lg:min-h-9 lg:min-w-9"
      >
        <svg width={26} height={26} viewBox="6 6 20 20" aria-hidden="true" focusable="false">
          <path
            className="wan-draw"
            d={STROKES}
            pathLength={1}
            fill="none"
            stroke="currentColor"
            strokeWidth={2.6}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {open ? (
        <span
          role="note"
          className="absolute right-0 top-full z-10 mt-2 w-max max-w-56 rounded-lg border border-border bg-surface px-3 py-2 text-sm text-fg shadow-lg"
        >
          <span className="font-medium">万歩</span> — «десять тысяч шагов». Японский шагомер так и назывался:
          万歩計.
        </span>
      ) : null}
    </span>
  )
}
